import React, { useState } from "react";
import axios from "axios";

const AdminCsvUpload = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        "https://hrgf.salepatner.com/api/import-report/",
        formData,
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("access")}`, // admin token
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(
        `✅ ${response.data.message} | Created: ${response.data.created}, Skipped: ${response.data.skipped}`
      );
    } catch (error) {
      if (error.response?.status === 403) {
        setMessage("❌ Only admins can upload CSVs.");
      } else {
        setMessage("❌ Error uploading CSV file.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-[#111827] min-h-screen text-white px-6">
      <div className="bg-[#1f2937] p-8 rounded-2xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center text-indigo-400">
          Upload Affiliate CSV Report
        </h2>

        <input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          className="w-full mb-4 bg-gray-800 text-gray-300 p-3 rounded-lg border border-gray-600 cursor-pointer"
        />

        <button
          onClick={handleUpload}
          disabled={loading}
          className={`w-full py-3 rounded-lg font-semibold transition-all ${
            loading
              ? "bg-gray-600 cursor-not-allowed"
              : "bg-indigo-500 hover:bg-indigo-600"
          }`}
        >
          {loading ? "Uploading..." : "Upload CSV"}
        </button>

        {message && (
          <p className="mt-4 text-center text-sm text-gray-300">{message}</p>
        )}
      </div>
    </div>
  );
};

export default AdminCsvUpload;
